module.exports = "//static.hsappstatic.net/marketplace-ui-details/static-1.9044/img/platinum-tier-icon-bordered.svg"